import endpoints from '@app/src/api/endpoints'
import { FetchKey, useFetchResource } from '@app/src/api/fetchHooks'
import type { CategoryOption } from '@app/src/types/categories'
import React from 'react'
import { useIntl } from 'react-intl'

interface CategoryOptionLabelProps {
  categoryOptionId: string
  categoryCount: number
  isLastItem: boolean
}

const CategoryOptionLabel = ({ categoryOptionId, categoryCount, isLastItem }: CategoryOptionLabelProps) => {
  const { formatMessage } = useIntl()

  const { data: category, isLoading } = useFetchResource<CategoryOption[]>({
    key: [FetchKey.CategoryOption, categoryOptionId],
    endpoint: endpoints.categoryOptionById(categoryOptionId),
    options: {
      enabled: Boolean(categoryOptionId),
    },
  })

  return (
    <>
      {category?.[0]?.name ?? formatMessage({ id: 'form.createAutomation.automationType.categoryDeleted' })}
      {!isLoading && categoryCount > 1 && !isLastItem && ', '}
    </>
  )
}

export default CategoryOptionLabel
